import axios from 'axios';
import authHeader from '../auth-header';
import tokenHeader from '../token-header';

import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";
const getArtikel = 'artikel';
const getDetailArtikel = 'artikel/';
const postArtikelUrl = 'artikel';
const putArtikel = 'artikel/';
const deleteArtikel = 'artikel/';
const exportArtikel = 'artikel-export';

class ArtikelService {    
    
    getArtikel(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getArtikel + '?pageNo=' + currentPage + '&pageSize=' + pageSize +'&filter='+filter,
            {
                headers: authHeader()
            });
    }

    getDetailArtikel(idArtikel) {
        return axios.get(
            API_URL + getDetailArtikel + idArtikel,
            {
                headers: authHeader()
            });
    }
    
    postArtikel(formData) {
        var headers = authHeader();        
        var form = new FormData();
        form.append("judul", formData.judul);
        if (typeof formData.flyer !== 'undefined') {
            form.append('flyer', formData.flyer);
        }
        form.append("isi", formData.isi);
        form.append("statusUpdateFlyer", "1");
        form.append("status", "1");
        return axios
            .post(API_URL + postArtikelUrl, form,{ 
            headers: { 'Content-Type': 'multipart/form-data','Authorization' : tokenHeader() } 
        })
        .then(response => {
            
            return response.data.message;
        });
    }

    putArtikel(formData) {
        var headers = authHeader();
        var form = new FormData();
        form.append("judul", formData.judul);
        if (typeof formData.flyer !== 'undefined') {
            form.append('flyer', formData.flyer);
        }
        form.append("isi", formData.isi);
        form.append("statusUpdateFlyer", "1");
        form.append("status", "1");
        return axios
        .put(
            API_URL + putArtikel + formData.idArtikel, form,
            { headers: { 'Content-Type': 'multipart/form-data','Authorization' : tokenHeader() }  }
        );
    }

    deleteArtikel(formData) {

        return axios
            .delete(
                API_URL + deleteArtikel + formData.idArtikel,
                { headers: authHeader() }
            );
    }

    exportArtikel() {
        return axios.get(API_URL + exportArtikel, {
            headers: authHeader(),
            responseType: 'blob',        
        });
    }

}

export default new ArtikelService();
